module.exports = __webpack_public_path__ + "img/id.aa8c023e.png";